import * as bootstrap from 'bootstrap';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    confirmationModalId: String
  };

  static classes = ['busy'];

  submit (e) {
    if (this.element.checkValidity()) {
      this.element.requestSubmit();
    } else {
      e.stopImmediatePropagation()
      this.element.reportValidity();
    }
  }

  lock () {
    this.element.classList.add(...this.busyClasses);
  }

  unlock () {
    this.element.classList.remove(...this.busyClasses);
  }

  displayConfirmationModal () {
    const modalEl = document.getElementById(this.confirmationModalIdValue);
    this.modalInstance = bootstrap.Modal.getOrCreateInstance(modalEl);

    if (this.element.reportValidity()) {
      this.modalInstance.show();
    }
  }
}
